/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { formatCurrency } from '../../../../shared/helper-utils/appUtils';
import AppButton from '../../../../shared/components/app-button/AppButton';
import { ESIM_ROUTES } from '../../constants/esimConstants';

export default function EsimTransactionListCard({ bookingData }) {
  const handleInvoiceClick = () => {
    const url = ESIM_ROUTES.INVOICE.replace(':transactionId', bookingData.txid);
    window.open(url, '_blank');
  };

  const handleVoucherClick = () => {
    const url = ESIM_ROUTES.VOUCHER.replace(':transactionId', bookingData.txid);
    window.open(url, '_blank');
  };
  return (
    <div className="cab-booking-list-card mb-2 p-2">
      <Row>
        <Col xs={12} md={12} lg={9}>
          <Row>
            <Col xs={12} sm={6} lg={5}>
              <div className="fs-12">Plan Name</div>
              <div className="fw-600">{bookingData.planname}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">validity</div>
              <div className="fw-600">{bookingData.validity} Days</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">New SIM Number</div>
              <div className="fw-600">{bookingData.mobile_no_api}</div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="fs-12">Booked On</div>
              <div className="fw-600">{bookingData.txdate?.split(' ')[0]}</div>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">pax Name</div>
              <div className="fw-600">
                {bookingData.paxfirstname} {bookingData.paxlastname}
              </div>
            </Col>
            {/* <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Children</div>
              <div className="fw-600">{bookingData.total_child}</div>
            </Col>
            <Col xs={12} sm={6} lg={2}>
              <div className="fs-12">Infants</div>
              <div className="fw-600">{bookingData.total_infants}</div>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <div className="fs-12">Validity</div>
              <div className="fw-600">
                {bookingData.validity} {bookingData.validity_type}
              </div>
            </Col> */}
          </Row>
        </Col>
        <Col xs={12} md={12} lg={3}>
          <div className="transaction-details">
            <div>
              <span>
                <b>Ref No: </b>
                {bookingData.sim_no_api}
              </span>
            </div>
            <div>
              <span>
                <b>Status: </b>
                {bookingData.bookingstatus}
              </span>
            </div>
            <div>
              <span className="fw-600">
                {formatCurrency(bookingData.totalfarequote)}
              </span>
            </div>
          </div>
          <div className="mt-2 d-flex gap-2 justify-content-end">
            <AppButton
              btnText="Invoice"
              variant="outlined"
              onClick={handleInvoiceClick}
            />
            <AppButton
              btnText="Voucher"
              variant="secondary"
              onClick={handleVoucherClick}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}
